export const themes = {
  CategoryNav: {
    ListContainer: `font-size: 0.875rem;`,
    SubcategoryHeaderLink: `margin-bottom: 0.5rem;`,
    SubcategoryLinkContainer: `margin-bottom: 0.5rem;`,
  },
  LeftNav: {
    ListContainer: `font-size: 0.75rem;`,
    SubcategoryHeaderLink: `margin-bottom: 0.625rem;`,
    SubcategoryLinkContainer: `margin-bottom: 0.625rem;`,
  },
};

export const CategoryNavTheme = themes['CategoryNav'];
export const LeftNavTheme = themes['LeftNav'];
export default themes['CategoryNav'];
